//theme color (purple)
export const secondaryColor = "#7E74F1";

//Font colors
export const fontColor = "#656D72";      //Grey font color 
export const secondFontColor = "#000";   //Black font color

//dark mode background color
export const darkbgcolor = "#282D3F";
export const halfdarkbgcolor =  "#2d3346";

//Light mode background color
export const fullbgcolor ="#fff";
export const bgcolor = " #FBFBFB";

//color behind the logo
export const logobgcolor =  "#f5f3fe";